<template>
  <v-flex
    v-if="!loading"
    xs12
    md8
    offset-md2
    align-self-center
    justify-center
  >
    <v-card flat light>
      <SubjectTabs
        :subject="subject"
        v-model="currentTab"
        @delete="deleteSubject"
        @edit="editSubject"
      />
      <v-tabs-items v-model="currentTab" light touchless>
        <v-tab-item value="subject">
          <SubjectDetails :subject="subject"/>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </v-flex>
  <Loader v-else/>
</template>

<script>
  import { mapActions } from 'vuex';

  import { subjectsService } from '../../utils/services/subjects.service';
  import SubjectTabs from '../../components/app/Subjects/SubjectTabs';
  import SubjectDetails from '../../components/app/Subjects/SubjectDetails';
  import SubjectModal from '../../components/modals/Subjects/SubjectModal';

  import Loader from '../../components/shared/Loader';

  export default {
    name: 'EditorShow',
    components: {
        Loader,
        SubjectTabs,
        SubjectDetails,
    },
    props: {
      id: [String, Number],
      tab: [String, Number],
    },
    data() {
      return {
        loading: false,
        currentTab: this.tab,
        subject: {},
      };
    },
    methods: {
      ...mapActions('confirm', ['showConfirm']),
      ...mapActions('alert', ['showToast']),
      ...mapActions('modal', ['showModal', 'hideModal']),
      async fetchSubject(id) {
        return subjectsService.get(id)
        .then(response => {
          this.subject = response.data.data;
        })
        .catch(error => {
          this.handleError(error, this.errors);
        });
      },
      async deleteSubject() {
        this.showConfirm({
            onConfirm: () => {
              this.loading = true;
              return subjectsService.remove(this.id)
              .then(() => {
                this.showToast({ type: 'success', message: this.$t('DELETED') });
                this.$router.push(`/${this.routeName.SUBJECT}`);
              })
              .catch(error => {
                this.handleError(error, this.errors);
              })
              .finally(() => {
                this.loading = false;
              });
            },
          });
      },
      async editSubject() {
          this.showModal({
              component: SubjectModal,
               data: {
                  stored: {
                    id: this.id,
                  },
              },
              options: {
                title: this.$t('SUBJECT'),
                onSave: (
                  form,
                  error,
                ) => subjectsService.save(form)
                .then(() => {
                  this.hideModal({});
                  this.showToast({ type: 'success', message: this.$t('SAVED') });
                })
                .catch(error => {
                  this.handleError(error, this.errors);
                })
                .finally(() => {
                  this.loading = false;
                }),
              },
            });
      },

    },
    async created() {
      this.loading = true;
      await this.fetchSubject(this.id);
      this.loading = false;
    },
  };
</script>
